module.exports = __webpack_public_path__ + "static/media/ritaDeLaFeria.f35139cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/images/authorSpotlight/ritaDeLaFeria.jpg
// module id = 1586
// module chunks = 1